<template>
  <div>
    <div>
      <l-map
        id="mapp"
        :key="count"
        ref="map"
        :zoom="zoom"
        :center="position"
        class="height-map-my"
        style="min-height: 300px; min-width: 300px; height: 68vh; width: 100%"
        :max-bounds="bounds"
        :min-zoom="minZoom"
      >
        <l-tile-layer :url="url" />
        <l-marker
          ref="marker"
          :lat-lng="position"
          :draggable="disableMap"
          @moveend="markerDragEnd"
        />
      </l-map>
    </div>
    <hr class="h-1">
    <div
      v-if="footer_coors"
      class="modal_footer w-100"
    >
      <b-row>
        <b-col cols="12">
          <div class="d-flex justify-content-start align-items-center">
            <div class="d-flex justify-content-between align-items-center mr-1">
              <label for="map_latitude">{{ $t('references.width') }}</label>
              <b-form-input
                id="map_latitude"
                v-model="markerPos.lat"
                type="number"
                class="ml-1 bg-white"
                min="-85"
                max="85"
                :disabled="!disableMap"
                @input="newPositionInput"
              />
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <label for="map_longitude">{{ $t('references.long') }}</label>
              <b-form-input
                id="map_longitude"
                v-model="markerPos.lng"
                type="number"
                class="ml-1 bg-white"
                min="0"
                max="180"
                :disabled="!disableMap"
                @input="newPositionInput"
              />
            </div>
          </div>
        </b-col>
        <!-- <b-col cols="6" class="d-flex justify-content-end">
          <b-button variant="primary" @click="setPosition"> Задать </b-button>
        </b-col> -->
      </b-row>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import { Icon } from 'leaflet'
import { BRow, BCol, BFormInput } from 'bootstrap-vue'

// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'), // eslint-disable-line global-require
  iconUrl: require('leaflet/dist/images/marker-icon.png'), // eslint-disable-line global-require
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'), // eslint-disable-line global-require
})
/* eslint-disable global-require */

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    BRow,
    BCol,
    BFormInput,
  },
  props: {
    activeMap: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default() {
        return {
          lat: '41.29475',
          lng: '69.24560',
        }
      },
    },
    disableMap: {
      type: Boolean,
      required: false,
      default: true,
    },
    footer_coors: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    showModal: false,
    markerPos: {
      lat: 0,
      lng: 0,
    },
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    zoom: 10,
    minZoom: 3,
    bounds: [
      { lat: -85, lng: -180 },
      { lat: 85, lng: 180 },
    ],
    count: 0,
  }),

  watch: {
    activeMap() {
      Object.assign(this.markerPos, this.position)
      this.fixMaxPosition()
    },
    position() {
      this.markerPos = this.position
    },
    // this.$nextTick(() => {
    //   // this.markerPos = {
    //   //   lat: this.position.lat,
    //   //   lng: this.position.lng,
    //   // }
    //   this.markerPos = this.position
    // })
  },

  updated() {
    this.updateMap()

    // this.$nextTick(() => {
    //   // this.markerPos = {
    //   //   lat: this.position.lat,
    //   //   lng: this.position.lng,
    //   // }
    //   this.markerPos = this.position
    // })
    // this.$nextTick(() => {
    //   this.activeMap = false;
    //   window.dispatchEvent(new Event("resize"));
    // });
  },
  mounted() {
    // this.$refs.map.mapObject.dragging.disable();
    // this.$refs.map.mapObject.touchZoom.disable();
    // this.$refs.map.mapObject.doubleClickZoom.disable();
    // this.$refs.map.mapObject.scrollWheelZoom.disable();
    // this.$refs.map.mapObject.boxZoom.disable();
    // this.$refs.map.mapObject.keyboard.disable();
    // if (this.$refs.map.tap) this.$refs.map.tap.disable();
    // document.getElementById('mapp').style.cursor='default';

    this.$nextTick(() => {
      // this.markerPos = {
      //   lat: this.position.lat,
      //   lng: this.position.lng,
      // }
      this.markerPos = this.position
    })
  },

  methods: {
    updateMap() {
      // для обновления карты
      // eslint-disable-next-line no-underscore-dangle
      this.$refs.map.mapObject._onResize()
    },

    markerDragEnd(value) {
      this.fixMaxPosition()
      let dragEndPos = {}
      // закидываю навое положение в маркер
      dragEndPos = {
        // eslint-disable-next-line no-underscore-dangle
        lat: value.target._latlng.lat.toFixed(5),
        // eslint-disable-next-line no-underscore-dangle
        lng: value.target._latlng.lng.toFixed(5),
      }

      //  задаю новое положение для объекта  с
      this.markerPos = dragEndPos

      const map = this.$refs.map.mapObject
      map.setView(this.markerPos)

      this.$nextTick(() => {
        this.setPosition()
      })
    },
    async newPositionInput() {
      await this.fixMaxPosition()
      const marker = this.$refs.marker.mapObject
      const map = this.$refs.map.mapObject
      // указываю рефы

      // задаю позицию маркеру
      marker.setLatLng(this.markerPos)
      // задаю позицию центру карты
      map.setView(marker.getLatLng())

      this.setPosition()
    },

    // функция для установления макимальной позиции
    fixMaxPosition() {
      if (this.markerPos.lat > 85) {
        this.$nextTick(() => {
          this.markerPos.lat = 85
        })
      } else if (this.markerPos.lat < -85) {
        this.$nextTick(() => {
          this.markerPos.lat = -85
        })
      }

      if (this.markerPos.lng > 180) {
        this.$nextTick(() => {
          this.markerPos.lng = 180
        })
      } else if (this.markerPos.lng < 0) {
        this.$nextTick(() => {
          this.markerPos.lng = 0
        })
      }
    },

    setPosition() {
      // эмичу новое положение объекта
      this.$emit('position', this.markerPos)
    },
  },
}
</script>
<style lang="scss">
.vue2leaflet-map {
  &.leaflet-container {
    height: 398px;
    z-index: 1;
  }
}
@import '~leaflet/dist/leaflet.css';
</style>
